import { translate } from 'i18n';

export const num = (v) => {
  const n = parseFloat(String(v ?? 0).replace(/,/g, ''));
  return Number.isFinite(n) ? n : 0;
};

export const money = (v, dec = 2) =>
  num(v).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });

export const diasHasta = (fecha) => {
  if (!fecha) return null;
  const d = new Date(`${String(fecha).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((d - hoy) / 86400000));
};

export const textoDias = (d) => {
  if (d === null) return '—';
  if (d === 0) return translate('mercado.hoy');
  return d === 1 ? translate('mercado.dia') : translate('mercado.dias', { n: d });
};

// Avance de financiación 0-100
export const avance = (p) => {
  const total = num(p.amount ?? p.amount_proyecto);
  if (!total) return 0;
  return Math.min(100, Math.round((num(p.amount_investment ?? p.amount_invertido) / total) * 1000) / 10);
};

export const normaliza = (t) => String(t ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// Fecha tolerante: acepta 2026-10-05, 2026-10-05 12:00:00 y 05/10/2026
export const aFecha = (s) => {
  const t = String(s || '');
  let m = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  m = t.match(/^(\d{2})[/-](\d{2})[/-](\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  return null;
};

export const fechaCorta = (s) => {
  const d = aFecha(s);
  return d ? d.toLocaleDateString('es-PA', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
};

// Porcentaje transcurrido entre dos fechas (0-100) y días restantes
export const transcurrido = (ini, fin) => {
  const a = aFecha(ini);
  const b = aFecha(fin);
  if (!a || !b || b <= a) return { pct: 0, dias: null };
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const pct = Math.min(100, Math.max(0, Math.round(((hoy - a) / (b - a)) * 100)));
  return { pct, dias: Math.max(0, Math.round((b - hoy) / 86400000)) };
};

// Código ISO (PA) → nombre en español (Panamá)
let _paises;
export const nombrePais = (iso) => {
  const c = String(iso || '').trim().toUpperCase();
  if (!c) return '';
  try {
    if (!_paises) _paises = new Intl.DisplayNames(['es'], { type: 'region' });
    const n = _paises.of(c);
    return n && n !== c ? n : c;
  } catch (e) {
    return c;
  }
};
